import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { TrackMode } from '@fitness-force/enum';

import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'track-mode',
  templateUrl: './track-mode.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class TrackModeComponent  {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null)

  getMode(value:any){
    console.log("track mode value",value)
    if (!value)
    return '-';
  else if (Object.keys(value).length === 0) {
    return '-';
  } else
    return TrackMode[value]
  }
}
